import { useInView } from "@/hooks/useInView";
import { UseCasesPhoneCarousel } from "./use-cases/UseCasesPhoneCarousel";

export const UseCases = () => {
  const { ref, isInView } = useInView({ threshold: 0.12 });

  return (
    <section
      id="use-cases"
      ref={ref}
      className="relative border-t border-border/40 bg-background py-16 md:py-20 scroll-mt-24"
    >
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_80%_50%_at_50%_30%,hsl(var(--primary)/0.08),transparent_55%)]"
        aria-hidden
      />

      <div className="container relative mx-auto max-w-7xl px-4">
        <UseCasesPhoneCarousel isInView={isInView} />
      </div>
    </section>
  );
};
